import { ComponentTypes } from "../../../config/config";
import { IFolderPanelInfo } from "../../../interfaces/IFolderPanelInfo";
import { IPageSettings } from "../../../interfaces/IPageSettings";
import { GetTeamSharepointInfo } from "../../../services/GraphService";
import { getRelativeDocumentUrl } from "../stringHelper";
import { isTeamsChannelLibraryRootChannel } from "../teamsChannelLocationHelper";
import { BaseFolderPanelHelper } from "./BaseFolderPanelHelper";
import { IFolderPanelHelper } from "../../../interfaces/IFolderPanelHelper";

export class TeamChannelFolderPanelHelper extends BaseFolderPanelHelper implements IFolderPanelHelper {
  constructor(
    private addWorkingDirectory: (
      location: IPageSettings
    ) => {
      type: "ADD_WORKING_DIRECTORY";
      payload: IPageSettings;
    },
    folderPanelInfo: IFolderPanelInfo,
    currentDirectory: IPageSettings,
    private languageStrings: any
  ) {
    super(folderPanelInfo, currentDirectory);
  }

  async getFolderFinalLocation(): Promise<IPageSettings> {
    const isRootDirectory = isTeamsChannelLibraryRootChannel(this.folderPanelInfo.teamChannelInfo) || !this.folderPanelInfo.folder.id;
    const channelDocumentLibrary = await GetTeamSharepointInfo(this.folderPanelInfo.folder.driveId);

    const value: IPageSettings = {
      ...this.getShareableSharepointProperties(),
      id: isRootDirectory ? this.folderPanelInfo.folder.driveId : this.folderPanelInfo.folder.id,
      parentId: isRootDirectory ? null : this.folderPanelInfo.folder.driveId,
      type: ComponentTypes.SharePointFolders,
      directory: getRelativeDocumentUrl(this.folderPanelInfo?.driveItemWebUrl ?? this.getDriveItemWebUrl(), isRootDirectory),
      DocumentLibrary: channelDocumentLibrary.documentLibraryName,
      isTeamsRootFolder: true,
      isTeamsFolder: true,
      isPrivateTeamsChannel: this.folderPanelInfo.teamChannelInfo?.isPrivate,
      isSharedTeamsChannel: this.folderPanelInfo.teamChannelInfo?.isShared,
      sharePointListId: channelDocumentLibrary.sharePointListId,
      webUrl: channelDocumentLibrary.sharePointSiteUrl
    };

    return value;
  }

  async save() {
    const isRootDirectory = isTeamsChannelLibraryRootChannel(this.folderPanelInfo.teamChannelInfo) || !this.folderPanelInfo.folder.id;
    const channelDocumentLibrary = await GetTeamSharepointInfo(this.folderPanelInfo.folder.driveId);
 
    let itemToAdd: IPageSettings = {
      id: isRootDirectory ? this.folderPanelInfo.folder.driveId : this.folderPanelInfo.folder.id,
      parentId: isRootDirectory ? null : this.folderPanelInfo.folder.driveId,
      type: ComponentTypes.Saving,
      siteId: this.currentDirectory.siteId,
      siteDisplayName: this.currentDirectory.siteDisplayName,
      webUrl: channelDocumentLibrary.sharePointSiteUrl,
      fileTitle: this.folderPanelInfo.folder.name,
      directory: getRelativeDocumentUrl(this.folderPanelInfo?.driveItemWebUrl ?? this.getDriveItemWebUrl(), isRootDirectory),
      DocumentLibrary: channelDocumentLibrary.documentLibraryName,
      displayName: this.languageStrings.Properties,
      isTeamsRootFolder: true,
      isTeamsFolder: true,
      isPrivateTeamsChannel: this.folderPanelInfo.teamChannelInfo?.isPrivate,
      isSharedTeamsChannel: this.folderPanelInfo.teamChannelInfo?.isShared,
      sharePointListId: channelDocumentLibrary.sharePointListId
    };

    this.addWorkingDirectory({...itemToAdd, isSaveLocationStructureSet: true});
  }

  private getDriveItemWebUrl = () => {
    const finalLocation = this.folderPanelInfo.locations[this.folderPanelInfo.locations.length - 1];
    return `${finalLocation.webUrl}/${finalLocation.directory}`;
  };
}
